/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Or_DividerInputs */

const en_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or`)
};

const ar_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أو`)
};

/**
* | output |
* | --- |
* | "or" |
*
* @param {Login_Or_DividerInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const login_or_divider = /** @type {((inputs?: Login_Or_DividerInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Or_DividerInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_or_divider(inputs)
	return ar_login_or_divider(inputs)
});